<template>
  <div v-editable="blok" :class="styles">
    <div class="grid-item" :key="index" v-for="(recipe,index) in lowest_priced">
      <recipe-card
        :blok="blok"
        @recipeView="onRecipeView(recipe,index)"
        @addToBasket="onAddToBasket(recipe,index)"
        @removeFromBasket="onRemoveFromBasket(recipe,index)"
        @selectRecipe="selectRecipe(recipe,index)"
        :disablePurchase="blok.disable_purchase"
        :allowDetails="allowDetails"
        :hidePrices="blok.hide_prices"
        :hoverable="selectable"
        :recipe="recipe"
      ></recipe-card>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import RecipeCard from '../RecipeCard.vue';

export default {
    name: 'recipesview-lowest-priced',
    props: {
        recipes: Array,
        blok:  Object,
        selectable: Boolean,
        allowDetails: Boolean
    },
    components: {
        RecipeCard
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences
        }),
        styles: function() {
            const b = this.$props.blok;
            return ['recipe-grid-simple', b.styles, b.item_size];
        },
        lowest_priced: function() {
            const r = [...this.$props.recipes]
            return r.sort( (a,b) => {
                const c = a.fractional_prices_for_portions[this.meal_preferences.people];
                const n = b.fractional_prices_for_portions[this.meal_preferences.people];
                return c-n;
            }).splice(0,Number(this.$props.blok.quantity_to_show));
        }
    },
    methods: {
        selectRecipe: function(recipe, index) {
            this.$emit('selectRecipe', {recipe,index});
            try {
                gtag('event', 'set_meal_plan', {'meal_plan': this.meal_preferences.meal_plan.toLowerCase(), 'non_interaction': true });
                gtag('event', 'set_people', {'people': this.meal_preferences.people, 'non_interaction': true });
                gtag('event', 'view_item', {
                    'event_label': recipe.id,
                });
                gtag('event', 'view_group', {
                    'event_category' : 'dietry-interest',
                    'event_label': recipe.food_group.toLowerCase()
                });
                gtag('event', 'view_quisine', {
                    'event_category' : 'dietry-interest',
                    'event_label': recipe.cuisine.toLowerCase()
                });
                gtag('event', 'view_group__' + recipe.food_group.toLowerCase(), {
                    'event_category' : 'dietry-interest',
                    'event_label': recipe.cuisine.toLowerCase()
                });
                gtag('event', 'cooking_time_in_minutes', {
                    'event_category' : 'dietry-interest',
                    'event_label': recipe.cooking_time_in_minutes
                });
                gtag('event', 'recipe_list_item_select', {
                    'event_category' : 'engagement',
                    'event_label': index
                });
            } catch(e) {
                console.warn(e);
            }
        },
        onAddToBasket: function(recipe,index) {
            this.$emit('addToBasket',{recipe,index});
        },
        onRemoveFromBasket: function(recipe,index) {
            this.$emit('removeFromBasket',{recipe,index});
        },
        onRecipeView: function(recipe,index) {
            this.$emit('recipeView',{recipe,index});
        }
    }
}
</script>